import { serverTimestamp, updateDoc, type DocumentReference } from 'firebase/firestore';
import { auth } from '@/lib/firebase';

/** Every client write is stamped (CLAUDE.md invariant 5; firestore.rules enforce it). */
export function stamp() {
  const uid = auth.currentUser?.uid;
  if (!uid) throw new Error('not signed in');
  return { updatedBy: uid, updatedAt: serverTimestamp() };
}

export function stampedUpdate(ref: DocumentReference, data: Record<string, unknown>) {
  return updateDoc(ref, { ...data, ...stamp() });
}
